import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { impetigoRoutes } from 'modules/forms/constants/routes.constants';
import Assessment from './Assessment';
import Confirmation from './Confirmation';
import Disqualification from '../Disqualification';
import GenerealQualifier from './GenerealQualifier';
import PhotoUpload from './PhotoUpload';
import Prescreening from './Prescreening';
import SecondaryScreening from './SecondaryScreening';
import FormAcceptTerms from '../FormAcceptTerms';

const FormRoutes = (): JSX.Element => {
  return (
    <Switch>
      <Route path={impetigoRoutes.prescreening} exact component={Prescreening} />
      <Route path={impetigoRoutes.generalQualifier} exact component={GenerealQualifier} />
      <Route path={impetigoRoutes.secondaryScreening} exact component={SecondaryScreening} />
      <Route path={impetigoRoutes.assessment} exact component={Assessment} />
      <Route path={impetigoRoutes.photoUpload} exact component={PhotoUpload} />
      <Route path={impetigoRoutes.acceptTerms} exact component={FormAcceptTerms} />
      <Route path={impetigoRoutes.disqualification} exact component={Disqualification} />
      <Route path={impetigoRoutes.confirmation} exact component={Confirmation} />
      <Redirect to={impetigoRoutes.prescreening} />
    </Switch>
  );
};

export default FormRoutes;
